<template>
  <module-template :id="id" :name="name" cssClass="module-method" width="190px" height="98px">
    <template slot="moduleContent">
      <button type='button' class='module-circle module-circle-input' style='margin-top: 28px; left: 5px' :id="id+'-cards'" @click="showModal('cards')"></button>
      <span class='module-circle-span' style='margin-top: 26px; left: 22px' @click="showModal('cards')">Cards</span>

      <button type='button' class='module-circle module-circle-input' style = 'margin-top: 45px; left: 5px' :id="id+'-ratioZ'" @click="showModal('ratioZ')"></button>
      <span class='module-circle-span' style='margin-top: 43px; left: 22px' @click="showModal('ratioZ')">Ratio Z</span>

      <button type='button' class='module-circle module-circle-input' style = 'margin-top: 62px; left: 5px' :id="id+'-decimalPlaces'" @click="showModal('decimalPlaces')"></button>
      <span class='module-circle-span' style='margin-top: 60px; left: 22px' @click="showModal('decimalPlaces')">Decimal Places</span>

      <button type='button' class='module-circle module-circle-input' style = 'margin-top: 79px; left: 5px' :id="id+'-weightType'" @click="showModal('weightType')"></button>
      <span class='module-circle-span' style='margin-top: 77px; left: 22px' @click="showModal('weightType')">Weight Type</span>
    </template>
  </module-template>
</template>

<script>
import {EventBus} from '@/event-bus.js'
import ModuleTemplate from '@/components/Workspace/Methods/ModuleTemplate'
export default {
  components: {
    ModuleTemplate
  },
  props: {
    id: String,
    name: String
  },
  methods: {
    showModal(tab) {
      EventBus.$emit('show-modal-'+this.id, tab);
    }
  },
  mounted: function () {
    var endpoints = [
      {id: this.id+'-cards', isSource: false},
      {id: this.id+'-ratioZ', isSource: false},
      {id: this.id+'-decimalPlaces', isSource: false},
      {id: this.id+'-weightType', isSource: false},
      {id: this.id+'-output', isSource: true}
    ];
    EventBus.$emit('add-endpoints', {id: this.id, endpoints: endpoints});
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Workspace/Methods/DCMSRFModule.vue